import { render, staticRenderFns } from "./CollarLeashProductGroup.vue?vue&type=template&id=457bd4d7&scoped=true&"
import script from "./CollarLeashProductGroup.vue?vue&type=script&lang=js&"
export * from "./CollarLeashProductGroup.vue?vue&type=script&lang=js&"
import style0 from "./CollarLeashProductGroup.vue?vue&type=style&index=0&id=457bd4d7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457bd4d7",
  null
  
)

export default component.exports